var _circle, _rect, _path, _path2, _path3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgHeroIcon2(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 100,
    height: 100,
    viewBox: "0 0 100 100",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 50,
    cy: 50,
    r: 50,
    fill: "#4A67FF"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 25,
    y: 32.5,
    width: 50,
    height: 35,
    rx: 6,
    fill: "white"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35 51.7578V48.9648L44.9414 44.7461V47.832L38.418 50.293V50.4297L44.9414 52.8906V55.9766L35 51.7578Z",
    fill: "#0000CC"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.1016 41.25L49.5508 58.1836H46.7383L51.2891 41.25H54.1016Z",
    fill: "#0000CC"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M65.8594 51.7578L55.918 55.9766V52.8906L62.4219 50.4297V50.293L55.918 47.832V44.7461L65.8594 48.9648V51.7578Z",
    fill: "#0000CC"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeroIcon2);
export default __webpack_public_path__ + "static/media/hero-icon-2.dddacae1d1a11144b451ae47cae10205.svg";
export { ForwardRef as ReactComponent };